import { PromoCodeVisibilityOverride } from 'models/Config'
import { api } from './index'

export type PromoCodesVisibility = {
  promoCodesVisibilityOverride: PromoCodeVisibilityOverride | null
}

type RawPromoCodesVisibilityConfig = {
  promo_codes_visibility_override: PromoCodeVisibilityOverride | null
}

type RawOrderingConfigResponse = {
  ordering_config: RawPromoCodesVisibilityConfig
}

export const toPromoCodesVisibility = (
  raw: RawOrderingConfigResponse
): PromoCodesVisibility => ({
  promoCodesVisibilityOverride:
    raw.ordering_config.promo_codes_visibility_override,
})

export const promoCodesVisibilityApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: build => ({
    getPromoCodesVisibility: build.query<PromoCodesVisibility, void>({
      query: () => 'ordering_config',
      transformResponse: toPromoCodesVisibility,
      providesTags: ['PromoCodesVisibility'],
    }),
    updatePromoCodesVisibility: build.mutation<
      PromoCodesVisibility,
      Partial<PromoCodesVisibility>
    >({
      query: config => ({
        url: 'ordering_config',
        method: 'PATCH',
        body: {
          ordering_config: {
            promo_codes_visibility_override:
              config.promoCodesVisibilityOverride,
          },
        },
      }),
      transformResponse: toPromoCodesVisibility,
      invalidatesTags: ['PromoCodesVisibility', 'OrderingConfig'],
    }),
  }),
})

export const {
  useGetPromoCodesVisibilityQuery,
  useUpdatePromoCodesVisibilityMutation,
} = promoCodesVisibilityApi
